import React from "react";
import { useLocation } from "react-router-dom";
import { company } from "../mock";

const waNumber = (company.whatsapp || "").replace(/[^0-9]/g, "");
const waHref = `https://wa.me/${waNumber}?text=${encodeURIComponent(
  "Hi Bhawani Kitchen Equipment, I'd like to know more about your kitchen equipment."
)}`;

export const FloatingWhatsApp = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <a
      href={waHref}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="floating-whatsapp-btn"
      className="group fixed bottom-5 right-5 z-50 flex items-center gap-2 rounded-full bg-[#25D366] text-white shadow-lg shadow-black/20 pl-3.5 pr-3.5 sm:pr-5 py-3.5 hover:bg-[#1ebe57] hover:-translate-y-0.5 transition-[transform,background-color] duration-200"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping -z-10" />
      <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
        <path d="M16.04 3C9.4 3 4 8.36 4 14.97c0 2.64.87 5.08 2.34 7.06L4.8 28l6.15-1.6a12.1 12.1 0 0 0 5.09 1.12h.01c6.63 0 12.03-5.36 12.03-11.97C28.08 8.36 22.68 3 16.04 3Zm0 21.9h-.01a9.97 9.97 0 0 1-5.07-1.39l-.36-.21-3.65.95.97-3.55-.24-.37a9.84 9.84 0 0 1-1.52-5.36c0-5.5 4.5-9.97 10.04-9.97 5.53 0 10.03 4.47 10.03 9.97 0 5.5-4.5 9.93-10.19 9.93Zm5.5-7.43c-.3-.15-1.78-.87-2.05-.97-.28-.1-.48-.15-.68.15-.2.3-.78.97-.96 1.17-.18.2-.35.22-.65.07-.3-.15-1.27-.46-2.42-1.48-.9-.79-1.5-1.77-1.67-2.07-.18-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.68-.51h-.58c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.48 0 1.47 1.07 2.88 1.22 3.08.15.2 2.1 3.2 5.08 4.48.71.31 1.27.49 1.7.63.72.22 1.37.19 1.88.12.57-.08 1.78-.72 2.03-1.42.25-.7.25-1.3.18-1.42-.08-.13-.28-.2-.58-.35Z" />
      </svg>
      <span className="hidden sm:inline font-semibold text-sm">Chat with us</span>
    </a>
  );
};
